/* Очаквана доставка.
   Смята се по софийско време. Прескачат се събота и неделя, а поръчките
   след определен час се броят от следващия работен ден. */
(function () {
  'use strict';

  var DAYS = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
  var MONTHS = ['януари', 'февруари', 'март', 'април', 'май', 'юни',
                'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'];

  function sofiaNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Sofia' }));
  }

  function isWorkday(d) {
    var n = d.getDay();
    return n !== 0 && n !== 6;
  }

  /* Добавя брой работни дни към дата. */
  function addWorkdays(from, count) {
    var d = new Date(from);
    var left = count;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkday(d)) left--;
    }
    return d;
  }

  function label(d) {
    return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }


  /* Датите по пътя на пратката. Всяка стъпка носи отместване в работни дни. */
  function initPath(root) {
    var lists = (root || document).querySelectorAll('[data-lp-path]');
    Array.prototype.forEach.call(lists, function (list) {
      if (list.dataset.lpPathOn === '1') return;
      list.dataset.lpPathOn = '1';

      var now = sofiaNow();
      var cells = list.querySelectorAll('[data-lp-path-date]');
      Array.prototype.forEach.call(cells, function (cell) {
        var off = parseInt(cell.dataset.lpPathDate, 10);
        if (isNaN(off)) off = 0;
        var d = off === 0 ? new Date(now) : addWorkdays(now, off);
        cell.textContent = d.getDate() + ' ' + MONTHS[d.getMonth()];
      });
    });
  }

  function init(root) {
    var rows = (root || document).querySelectorAll('[data-lp-deliv]');
    Array.prototype.forEach.call(rows, function (row) {
      if (row.dataset.lpDelivOn === '1') return;
      row.dataset.lpDelivOn = '1';

      var out = row.querySelector('[data-lp-deliv-text]');
      if (!out) return;

      var min    = parseInt(row.dataset.min, 10) || 1;
      var max    = parseInt(row.dataset.max, 10) || 2;
      var cutoff = parseInt(row.dataset.cutoff, 10);
      if (isNaN(cutoff)) cutoff = 15;

      var now = sofiaNow();

      /* Отправната точка е днес; след часа на приемане — следващият работен ден. */
      var base = new Date(now);
      if (now.getHours() >= cutoff || !isWorkday(now)) {
        base = addWorkdays(base, 1);
        base.setHours(0, 0, 0, 0);
      }

      var first = addWorkdays(base, min);
      var last  = addWorkdays(base, max);

      if (min === max || first.getTime() === last.getTime()) {
        out.innerHTML = 'Поръчайте сега и я получавате <strong>' + label(first) + '</strong>';
      } else {
        out.innerHTML = 'Поръчайте сега и я получавате между <strong>' + label(first) +
                        '</strong> и <strong>' + label(last) + '</strong>';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initPath(); });
  } else {
    init(); initPath();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initPath(e.target); });
})();
